var map = {
	"./3pa.png": 1093,
	"./EOS.png": 9492,
	"./Finschia.png": 7734,
	"./IXSwap.png": 8545,
	"./Kaia.png": 9429,
	"./Klaytn.png": 9782,
	"./NPY.png": 2384,
	"./PT.png": 3627,
	"./Pala.png": 4115,
	"./Polygon.png": 3165,
	"./SBINFT.png": 2567,
	"./VASP.png": 2497,
	"./agate.png": 4627,
	"./bitget.png": 144,
	"./bithumb.png": 5950,
	"./bittrex.png": 6063,
	"./bloom.png": 2894,
	"./boomco.png": 4552,
	"./cabinet.png": 6455,
	"./catalyze.png": 4156,
	"./coinness.png": 857,
	"./coinone.png": 1658,
	"./cube.png": 7520,
	"./drawshop.png": 165,
	"./elysia.png": 7958,
	"./epic.png": 3720,
	"./f.png": 3849,
	"./gate.png": 426,
	"./gopax.png": 3886,
	"./havah.png": 6818,
	"./huobi.png": 3696,
	"./hyperithm.png": 423,
	"./indodax.png": 5390,
	"./jeff.png": 9124,
	"./kana.png": 6732,
	"./klaydice.png": 5609,
	"./klaymeta.png": 7323,
	"./kns.png": 8225,
	"./kobit.png": 8656,
	"./lazy.png": 6153,
	"./lena.png": 7785,
	"./lilli.png": 5345,
	"./magmabyte.png": 1154,
	"./metabeat.png": 5360,
	"./meverse.png": 9406,
	"./mexc.png": 1966,
	"./miracle.png": 5918,
	"./nwz.png": 6970,
	"./oneplanet.png": 5005,
	"./ozys.png": 3856,
	"./patex.png": 1991,
	"./perplay.png": 9072,
	"./pilab.png": 4945,
	"./pixelplay.png": 4433,
	"./post.png": 3729,
	"./preto.png": 7975,
	"./probit.png": 3341,
	"./rei.png": 5439,
	"./searchfi.png": 5216,
	"./sheepfarm.png": 6382,
	"./ssx.png": 1769,
	"./stat.png": 6729,
	"./tangle.png": 2826,
	"./ticker.png": 5061,
	"./trip.png": 9966,
	"./xticket.png": 6603,
	"./yooldo.png": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9164;